import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--admin-hub/adminhub-inbox-recommendation';

import { InboxRecommendationCard as RecommendationCard } from '@post-office/ax-tesseract--common';

import { ManualMessageViewedEvent } from '@post-office/placement-contexts/message-viewed-component';

import { type EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';

import { type MessageTemplateContext } from '../../../index';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps;

const render = PlacementFrontend.createFrontendStage({
	type: 'render',
	validate: (props: RenderProps) => {
		assertMessageTemplateContext(props);

		return props;
	},
	Component: ({ eligibleMessages, ...props }: RenderProps) => (
		<ManualMessageViewedEvent>
			<RecommendationCard
				{...props}
				eligibleMessages={
					eligibleMessages as unknown as (EligibleMessage & MessageTemplateContext)[]
				}
			/>
		</ManualMessageViewedEvent>
	),
});

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render,
});
